import Image from 'next/image';
import styled from 'styled-components';
import { Container, ContainerContentStandard } from '../../../../../shared/styles/container';
import { device } from '../../../../../shared/styles/device';
import CircleSVG from '/public/svg/talentpool/agenturen/circle.svg';

const HeroImageWrapper = styled.div`
    background-color: #FFFFFF;
    display: flex;
    align-items: flex-end;
    position: relative;
    max-height: 100vh;
    width: 100%;
    margin-bottom: 64px;
`;

interface HeadlineProps {
  readonly primary?: boolean;
};

const Headline = styled.h1<HeadlineProps>`
    color: ${props => props.primary ? props.theme.colors.primary : props.theme.colors.fontBlack};
    line-height: 98px;
    margin-bottom: 32px;
    margin-top: 32px;
    text-align: center;

    span {
      color: ${props => props.theme.colors.primary};
    }

    @media(max-width: 768px) {
      font-size: 36px;
      line-height: 60px;
    }
`;


const HeroGrid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-row-gap: 32px;

  @media ${device.tablet} {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 32px;
  }
`;

const GridItem = styled.div`
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    grid-row-gap: 40px;
    justify-content: flex-start;
    text-align: left;

  @media ${device.tablet} {
  }

  h3 {
    margin: 0;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
  }

  h4 {
    margin: 0;
    font-weight: 500;
    font-size: 16px;
  }

  svg {
    margin-right: 16px;
  }
`;
export const HeroIntroAgenturen = () => {
  return (
    <Container centered>
      <ContainerContentStandard>
        <Headline>Der <span>Talentpool</span> für Ihr Unternehmen.</Headline>
        <HeroImageWrapper>
          <Image
            src="/images/talentpool/landingagentur/mac.jpg"
            alt="easyboarding Treffen Meeting"
            layout='fixed'
            quality={100}
            height={699}
            width={1200}
            objectPosition="center"
            objectFit='contain'
            priority={true}
          />
        </HeroImageWrapper>
        <HeroGrid>
          <GridItem>
            <CircleSVG />
            <div>
              <h3>Eine Lizenz – viele Talente</h3>
              <h4>Sichern Sie sich jetzt die easyboarding-Talentpool-Lizenz, um die aktuellen Talente der Touristik kennenzulernen</h4>
            </div>
          </GridItem>
          <GridItem>
            <CircleSVG />
            <div>
              <h3>Filtern Sie nach Präferenzen</h3>
              <h4>Durch die intelligente Filterfunktion lässt sich unser Talentpool auf diejenigen Talente untersuchen, die für Ihre Vakanzen relevant sind</h4>
            </div>
          </GridItem>
          <GridItem>
            <CircleSVG />
            <div>
              <h3>Ersteindrücke gewinnen</h3>
              <h4>Schauen Sie sich die Einzelprofile an, in welchen die Talente ihre Skills, Arbeitserfahrungen und Anstellungsvorlieben transparent kommunizieren</h4>
            </div>
          </GridItem>
          <GridItem>
            <CircleSVG />
            <div>
              <h3>Bewerten und vergleiche Sie die Profile</h3>
              <h4>Markieren Sie die Profile mit einer Bewertung und gehen Sie in den Direktvergleich, um anschließend Kontakt zu den spannendsten Talenten aufzunehmen</h4>
            </div>
          </GridItem>
        </HeroGrid>
      </ContainerContentStandard>
    </Container>
  )
}
